import * as wActs from './website-actions.js';
import * as wConst from '../consts/website-consts';
import { fetch, addTask } from "domain-task";

export function GetBillingData() {
  return function(dispatch) {
    dispatch({type: wConst.FETCH_BILLING_PENDING, payload: true});
    let headers = {}
    fetch(`/billing/billers.json`, {headers: headers})
      .then(resp => resp.json())
      .then(function (data) {
        dispatch({type: wConst.FETCH_BILLING_FULLFILLED, payload: data});
      }).catch(function (ex) {
        dispatch(wActs.showWarning("WARN", "Could not load billing data",2500));
        dispatch({type: wConst.FETCH_BILLING_REJECTED, payload: ex.toString()});
        return;
      }
    );
  }
}

export function VXSCreateOrder(packId, cc, hcc, userId, sDate, guId, cultPath, curCode) {
  return (dispatch,getState) => {
    dispatch({type: wConst.VXS_CREATEORDER_PENDING, payload: false});
    let headers = {};
    fetch(
      `/api/vxs/createorder?packId=${packId}&cc=${encodeURIComponent(cc)}&hcc=${encodeURIComponent(hcc)}&userId=${encodeURIComponent(userId)}`
      + `&sDate=${encodeURIComponent(sDate)}&guId=${encodeURIComponent(guId)}&cultPath=${encodeURIComponent(cultPath)}&curCode=${encodeURIComponent(curCode)}`
      ,{headers: headers})
      .then(resp => resp.json())
      .then(function (data) {
        dispatch({type: wConst.VXS_CREATEORDER_FULLFILLED, payload: data});
      }).catch(function (ex) {
        dispatch(wActs.showWarning("WARN", "Could not call createorder api",2500));
        dispatch({type: wConst.VXS_CREATEORDER_REJECTED, payload: ex.toString()});
        return;
      }
    );
  }
}

export function VXSCheckOrder(orderId, packId, cc, hcc, userId, recId, sDate, guId, cultPath, curCode, tUrl) {
  return (dispatch,getState) => {
    dispatch({type: wConst.VXS_CHECKORDER_PENDING, payload: false});
    let headers = {};
    fetch(
      `/api/vxs/checkorder?orderid=${orderId}&packId=${packId}&cc=${encodeURIComponent(cc)}&hcc=${encodeURIComponent(hcc)}&userId=${encodeURIComponent(userId)}&recId=${recId}`
      + `&sDate=${encodeURIComponent(sDate)}&guId=${encodeURIComponent(guId)}&cultPath=${encodeURIComponent(cultPath)}&curCode=${encodeURIComponent(curCode)}&targetUrl=${encodeURIComponent(tUrl)}`
      ,{headers: headers})
      .then(resp => resp.json())
      .then(function (data) {
        dispatch({type: wConst.VXS_CHECKORDER_FULLFILLED, payload: data});
      }).catch(function (ex) {
        dispatch(wActs.showWarning("WARN", "Could not call checkorder api",2500));
        dispatch({type: wConst.VXS_CHECKORDER_REJECTED, payload: ex.toString()});
        return;
      }
    );
  }
}